export default __webpack_public_path__ + "static/media/TECD logo 1.cde0ab58.png";